export default {"src":"/_next/static/media/swiss-logo.c8d6701a.svg","height":26,"width":78,"blurWidth":0,"blurHeight":0};